import React from 'react';
import styled from '@emotion/styled';
import { SubScreenLayoutSelector } from 'components/views/molecules/SubScreenLayoutSelector';

const Root = styled.div({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#279BE4',
    minHeight: '64px',
});

const LeftItems = styled.div({
    display: 'flex',
    alignItems: 'center',
    padding: ['12px', '19px'],
});

export type SideNavigationBarProps = {
    numberOfScreens: number;
    selected: number | null;
    onSelect: (selected: number) => void;
}

export const SideNavigationBar = (props: SideNavigationBarProps) => {
    return (
        <Root>
            <LeftItems>
                <SubScreenLayoutSelector {...props} />
            </LeftItems>
        </Root>
    );
};
